"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var cssProperties_1 = require("../constants/cssProperties");

var scales_1 = require("../constants/scales");

var maxWidth = function maxWidth(props) {
  if (props === void 0) {
    props = {};
  }

  var styles = {};

  if (props.mw) {
    if (scales_1.fixedScale[props.mw]) {
      styles['max-width'] = scales_1.fixedScale[props.mw] + "px";
    } else if (props.mw === '100' || props.mw === 100) {
      styles['max-width'] = '100%';
    } else if (typeof props.mw === 'string' && cssProperties_1.globalCssProperties.indexOf(props.mw) >= 0) {
      styles['max-width'] = props.mw;
    }
  }

  return styles;
};

exports.default = maxWidth;